import { defineMessages } from 'react-intl';

const messages = defineMessages({
  shareYourCalendar: {
    id: 'share-calendar-modal.shareYourCalendar',
    defaultMessage: 'Share Your Calendar',
  },
  shareYourCalendarDescription: {
    id: 'share-calendar-modal.shareYourCalendarDescription',
    defaultMessage: 'Creating an ical subscription allows you to view your RepVisits calendar in other calendar applications, including Outlook and Google.', // eslint-disable-line max-len
  },
  googleCalendar: {
    id: 'share-calendar-modal.googleCalendar',
    defaultMessage: 'Google Calendar',
  },
  outlookOthers: {
    id: 'share-calendar-modal.outlookOthers',
    defaultMessage: 'Outlook and Others',
  },
  mailPlaceholder: {
    id: 'share-calendar-modal.mailPlaceholder',
    defaultMessage: 'you@domain.com',
  },
  share: {
    id: 'share-calendar-modal.share',
    defaultMessage: 'Share',
  },
  email: {
    id: 'share-calendar-modal.email',
    defaultMessage: 'Email Address',
  },
  enterValidEmail: {
    id: 'share-calendar-modal.enterValidEmail',
    defaultMessage: 'Please enter a valid email',
  },
  shareGoogleDescription: {
    id: 'share-calendar-modal.shareGoogleDescription',
    defaultMessage: 'Email address must be associated with a Google Acount.',
  },
  shareGoogleLoadingTitle: {
    id: 'share-calendar-modal.shareGoogleLoadingTitle',
    defaultMessage: 'Hang tight! Your calendar is being prepped',
  },
  shareGoogleLoadingDescription: {
    id: 'share-calendar-modal.shareGoogleLoadingDescription',
    defaultMessage: 'The recipient will receive an email notification once they\'re successfully subscribed to your RepVisits calendar.',
  },
  shareGoogleLoadingHint: {
    id: 'share-calendar-modal.shareGoogleLoadingHint',
    defaultMessage: 'You may continue using the app.',
  },
  shareGoogleReadyTitle: {
    id: 'share-calendar-modal.shareGoogleReadyTitle',
    defaultMessage: 'Your calendar is ready',
  },
  shareGoogleReady: {
    id: 'share-calendar-modal.shareGoogleReady',
    defaultMessage: 'and was successfully shared!',
  },
  googleSubscriber: {
    id: 'share-calendar-modal.googleSubscriber',
    defaultMessage: 'Subscriber',
  },
  googleUnsubscribe: {
    id: 'share-calendar-modal.googleUnsubscribe',
    defaultMessage: 'unsubscribe',
  },
  googleSubscriberHint1: {
    id: 'share-calendar-modal.googleSubscriberHint1',
    defaultMessage: 'You\'re allowed one subscriber at a time.',
  },
  googleSubscriberHint2: {
    id: 'share-calendar-modal.googleSubscriberHint2',
    defaultMessage: 'To add a new one remove the current subscriber.',
  },
  googleSubscriberRemoved: {
    id: 'share-calendar-modal.googleSubscriberRemoved',
    defaultMessage: 'Subscriber removed',
  },
  googleCalendarNotCreated: {
    id: 'share-calendar-modal.googleCalendarNotCreated',
    defaultMessage: 'Calendar couldn\'t be created',
  },
  googleCalendarNotCreatedDetails: {
    id: 'share-calendar-modal.googleCalendarNotCreatedDetails',
    defaultMessage: 'See details',
  },
  googleCalendarNotCreatedDescription: {
    id: 'share-calendar-modal.googleCalendarNotCreatedDescription',
    defaultMessage: 'There was a problem exporting some of your calendar appointments. Unsubscribe this email address and try again.',
  },
  importICalendar: {
    id: 'share-calendar-modal.importICalendar',
    defaultMessage: 'Import the following iCalendar (.ics) to your calendar application:',
  },
  copy: {
    id: 'share-calendar-modal.copy',
    defaultMessage: 'Copy',
  },
  importICalendarDescription: {
    id: 'share-calendar-modal.importICalendarDescription',
    // eslint-disable-next-line max-len
    defaultMessage: `This is a private URL for personal use. People with this URL will have access to your calendar, so be careful how you share it.{linebreak}{linebreak}
<b>IMPORTANT: Google calendar checks ical every few hours and it may take up to 12 hours for your RepVisits to update your Google calendar.  Your RepVisits ical subscription with Outlook will accurately reflect all appointments and cancellations within the hour. For more information please reference the help library.</b>`, // eslint-disable-line max-len
  },
  resetURL: {
    id: 'share-calendar-modal.resetURL',
    defaultMessage: 'Reset the URL',
  },
  iCalURLCreated: {
    id: 'share-calendar-modal.iCalURLCreated',
    defaultMessage: 'New iCal URL created',
  },
  loading: {
    id: 'share-calendar-modal.loading',
    defaultMessage: 'loading ...',
  },
  tryAgain: {
    id: 'share-calendar-modal.tryAgain',
    defaultMessage: 'Please try again later.',
  },
  iCalURLNotCreated: {
    id: 'share-calendar-modal.iCalURLNotCreated',
    defaultMessage: 'There was a problem resetting the URL.',
  },
  subscriberNotRemoved: {
    id: 'share-calendar-modal.subscriberNotRemoved',
    defaultMessage: 'There was a problem removing the subscriber.',
  },
});

export default messages;
